import TaxonomyAdminScreen from "../taxonomy/taxonomy-admin-screen.tsx";

export default function CategoriesScreen() {
  return <TaxonomyAdminScreen type="categories" title="دسته‌بندی‌ها" />;
}
